/*
  Noah.Q mobile social loop v199
  Code cleanup only.

  Adds .is-mobile-auto-active to SNS cards every 1100ms on mobile.
*/

(() => {
  const root = document.getElementById('noahq-buzz');
  if (!root) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let timer = null;
  let index = 0;

  const getCards = () => Array.from(root.querySelectorAll('.noahq-social-link-card:not(.noahq-social-link-card--empty)'));

  const clearActive = () => {
    getCards().forEach((card) => card.classList.remove('is-mobile-auto-active'));
  };

  const shouldRun = () => mobileQuery.matches && !reduceQuery.matches && !document.hidden;

  const tick = () => {
    const cards = getCards();
    if (!shouldRun() || cards.length === 0) {
      clearActive();
      return;
    }

    cards.forEach((card, cardIndex) => {
      card.classList.toggle('is-mobile-auto-active', cardIndex === index);
    });

    index = (index + 1) % cards.length;
  };

  const stop = () => {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
    clearActive();
  };

  const start = () => {
    stop();

    if (!shouldRun()) return;

    index = 0;
    tick();
    timer = window.setInterval(tick, 1100);
  };

  mobileQuery.addEventListener?.('change', start);
  reduceQuery.addEventListener?.('change', start);
  document.addEventListener('visibilitychange', start);

  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);

  start();
})();
